"use strict";
exports.__esModule = true;
exports.VerificationStatus = exports.VerificationType = void 0;
var VerificationType;
(function (VerificationType) {
    // IV
    VerificationType["BANK_ACCOUNT"] = "BANK_INCOME";
    VerificationType["DOCUMENT"] = "PAY_STUB_INCOME";
    // DOCV
    VerificationType["IDENTITY_DOCUMENT"] = "IDENTITY_DOCUMENT";
})(VerificationType = exports.VerificationType || (exports.VerificationType = {}));
var VerificationStatus;
(function (VerificationStatus) {
    VerificationStatus["STEP_UP"] = "STEP_UP";
    VerificationStatus["PENDING"] = "PENDING";
    VerificationStatus["MANUAL_REVIEW"] = "MANUAL_REVIEW";
    VerificationStatus["COMPLETED"] = "COMPLETED";
    VerificationStatus["EXPIRED"] = "EXPIRED";
    VerificationStatus["VENDOR_FAILURE"] = "VENDOR_FAILURE";
    VerificationStatus["SUBMITTED"] = "SUBMITTED";
})(VerificationStatus = exports.VerificationStatus || (exports.VerificationStatus = {}));
